module.exports = __webpack_public_path__ + "static/web-banner-assistcard-65fcd954a1220f21897d201f631433d9.jpg";